module.exports = __webpack_public_path__ + "static/polygram-2af425cf1c906bfdbf767d19460e01fe.png";